import * as CopcLib from 'copc';
import {
  appendSasToken,
  PointCloudCopcGeometry,
  PointCloudEptGeometryNode,
} from './ept-geometry';

export class CopcLoader {
  /**
   * Load a COPC point cloud from a .copc.laz URL.
   * @param file - URL to the COPC file
   * @param signal - Optional AbortSignal for cancellation
   */
  static async load(file: string, signal?: AbortSignal): Promise<any> {
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');

    const { Copc, Getter } = CopcLib;

    // Resolve the token per range request so hierarchy and point reads survive token refresh.
    const getter: CopcLib.Getter = (begin, end) => Getter.http(appendSasToken(file))(begin, end);
    const copc = await Copc.create(getter);

    const geometry = new PointCloudCopcGeometry(getter, copc);
    const root = new PointCloudEptGeometryNode(geometry);

    geometry.root = root;
    root.load();

    return geometry;
  }
}
